import {lazy, Suspense} from 'react';
import {FormActions} from '@legit.health/ui';
import {Box, Grid2} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn, useWatch} from 'react-hook-form';
import AppSkeleton from '@/components/AppSkeleton';
import {useParamsContext} from '@/contexts/ParamsContext';
import FormValues from '../../interfaces/FormValues';
import LesionTypeField from './components/LesionTypeField';
const MacroscopicMediaField = lazy(() => import('./components/MacroscopicMediaField'));
const LesionInstructions = lazy(() => import('./components/LesionInstructions'));
const ImageField = lazy(() => import('./components/ImageField'));

export default function UploadImages({
  t,
  form,
  isPending,
  isSuccess
}: {
  t: TFunction;
  form: UseFormReturn<FormValues>;
  isPending: boolean;
  isSuccess: boolean;
}) {
  const {macroscopicMedia: macroscopicMediaParam} = useParamsContext();
  const lesionType = useWatch({
    control: form.control,
    name: 'lesionType'
  });
  const bodySite = useWatch({
    control: form.control,
    name: 'bodySiteCode'
  });
  if (bodySite === '') {
    return null;
  }

  return (
    <Box>
      <Box mb={4}>
        <LesionTypeField form={form} t={t} />
      </Box>
      {lesionType && (
        <Suspense fallback={<AppSkeleton />}>
          <Grid2 container mb={4} rowGap={4}>
            <Grid2 size={{xs: 12, lg: 6}}>
              <LesionInstructions t={t} />
            </Grid2>
            <Grid2 size={{xs: 12, lg: 6}}>
              <ImageField form={form} t={t} />
            </Grid2>
          </Grid2>
          {macroscopicMediaParam !== 'disabled' && (
            <Box mb={4}>
              <MacroscopicMediaField t={t} form={form} />
            </Box>
          )}
          <FormActions
            isPending={isPending}
            isSuccess={isSuccess}
            actionButtonText={t('ui:send')}
            actionButtonTextSending={t('ui:sending')}
          />
        </Suspense>
      )}
    </Box>
  );
}
